import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Upload } from 'lucide-react';
import { ClearDraftsButton, type ClearScope } from './ClearDraftsButton';
import { TableToolbarButton } from './TableToolbarButton';

interface DraftTableToolbarProps {
  onUpload: () => void;
  onClear: () => void;
  /** Clear only offers itself while it has something to remove (per clearScope) */
  canClear: boolean;
  /** What clearing removes — picks the confirm dialog copy */
  clearScope?: ClearScope;
  /** Further import buttons beside Excel importieren */
  importActions?: ReactNode;
}

/**
 * The one header toolbar of every wizard draft table: Excel importieren is
 * always available (a repeat import merges into the current rows), Liste
 * leeren appears once there are drafts.
 */
export function DraftTableToolbar({
  onUpload,
  onClear,
  canClear,
  clearScope = 'drafts',
  importActions
}: DraftTableToolbarProps) {
  const { t } = useTranslation();

  return (
    <>
      <TableToolbarButton onClick={onUpload}>
        <Upload className="size-3.5!" />
        {t('initialSetup.uploadFromExcel')}
      </TableToolbarButton>
      {importActions}
      {canClear && <ClearDraftsButton onClear={onClear} scope={clearScope} />}
    </>
  );
}
